export type Goals =
  | 'selected source'
  | 'started recording'
  | 'started delayed recording'
  | 'finished recording'
  | 'user denied access'
  | 'recording cancelled';

export class PlEvent extends Event {
  constructor(public plEventData: { goal: Goals; props?: any }) {
    super('86b19c2b-9f2e-481e-b042-e3bf84700d2a');
  }
}
